'use strict';

import Vue from 'vue'
import Routes from '@expressive-analytics/vue-routes'
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)
import VueRouter from 'vue-router'
import Relay from "system/relay"
import route_config from "config/routes.yml"
Vue.use(VueRouter)
import Store from "system/store"

let App = {
  init(){ // this is called once during bootstrap (see app/index.js)
    // Build app navigation routes from config/routes.json
    Routes.parseRoutes(route_config)
    Routes.addRoute({path:'*',redirect:'/'}) // handle unknown paths
    var routes = Routes.routes()
    const router = new VueRouter({mode: 'history', routes: routes})

    var main_title = document.title
    router.beforeEach((to,from,next)=>{
      document.title = to.meta.title?to.meta.title:main_title

      // Pre-flight check for secure pages (prevents flicker)
      // 'privileged': preloads user credentials into $route.meta.user
      // 'protected' redirects unauthorized users
      var security = "public"
      for(var k in to.matched){ // find the nearest security level
        var r = to.matched[k]
        security = r.meta.security?r.meta.security:security
      }
      if(security!="public"){
        const cached_user = JSON.parse(localStorage.getItem("user"))
        var params = {act:"current_user"}
        if(security=="privileged")
          params.noauth=true
        if(cached_user){
          Store.commit('authorize',cached_user)
          Relay.get("SecureUser",params,(response)=>{
            if(response && response.obj)
              Store.commit('authorize',response.obj)
          })
          next() // don't wait around for the new user data
        }else{
          if(to.name!="login")
            localStorage.setItem("protected_url",to.fullPath)
          Relay.get("SecureUser",params,(response)=>{
            if(response && response.obj)
              Store.commit('authorize',response.obj)
            next()
          })
        }
      }else
        next()
    })

    // scroll to top
    router.beforeEach((to, from, next) => {
      window.scrollTo(0, 0);
      next();
    });

    App = new Vue({"router":router}).$mount("#app")
  }
}
export default App
